import config from '../config';
import pollingService from './pollingService';
import signalRService from './signalRService';

// All chat UI consumers must use the same transport as authentication.
const chatService = config.usePolling ? pollingService : signalRService;
export default chatService;
